import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import Footer from '../Footer/Footer';

function withBaseLayout(WrappedComponent) {
  class WithBaseLayout extends React.Component {
    componentDidMount() {
      const { scrollToTop } = this.props;
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
    }

    render() {
      const { classes } = this.props;

      return (
        <div className={`${classes.root} PageLayout`} id='main' tabIndex='0'>
          <WrappedComponent {...this.props} />
          <Footer />
        </div>
      );
    }
  }

  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  WithBaseLayout.displayName = `withBaseLayout(${wrappedComponentName})`;

  WithBaseLayout.propTypes = {
    classes: PropTypes.object.isRequired,
    scrollToTop: PropTypes.bool,
  };

  WithBaseLayout.defaultProps = {
    scrollToTop: true,
  };

  return withStyles(styles, { withTheme: true })(WithBaseLayout);
}

export default withBaseLayout;
